import React, { Component } from 'react';
class TableList extends Component {
  render() {
    return <div>List</div>;
  }
}

export default TableList;
